import type { Customer } from "~/common/interfaces/entities/customer.interface";

export const getCustomerDefault = (): Customer => ({
	id: 0,
	firstName: "",
	lastName: "",
	email: "",
	phoneNumber: "",
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	orders: []
});
